import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/BusinessInquiryForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BusinessPageHero","BusinessTrustSectionBase","BusinessServicesSection","WhyBusinessesChooseUsSectionBase","IndustriesSection","BusinessHowItWorksSection"] */ "/opt/build/repo/src/components/BusinessSections.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/CTABanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/FaqSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/Header.tsx");
